export const fnyfsProviderId = "00000000-0000-0000-0000-000000000000";
export const fnyfsName = "Florida Network";
